export const APP_NAME = 'Dialworks';
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const ADMIN_PREFIX_PATH = '/admin'; // can only accesible to admin